var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50281 10.4595C7.50095 10.433 7.5 10.4062 7.5 10.3792V1.87286C7.5 1.28592 7.947 0.80957 8.5 0.80957C9.053 0.80957 9.5 1.28592 9.5 1.87286V10.379L11.9002 8.46509C12.3422 8.11101 12.9692 8.20777 13.3002 8.67775C13.6322 9.14772 13.5422 9.8144 13.1002 10.1664L9.10021 13.3562C8.92321 13.4976 8.71121 13.5689 8.50021 13.5689C8.29921 13.5689 8.09821 13.504 7.92521 13.3754L3.92521 10.3833C3.47321 10.0451 3.36421 9.38164 3.68221 8.9021C4.00021 8.42149 4.62321 8.30559 5.07521 8.64372L7.50281 10.4595ZM2.5 15.6956V16.7589H14.5V15.6956C14.5 15.1108 14.95 14.6324 15.5 14.6324C16.05 14.6324 16.5 15.1108 16.5 15.6956V17.8222C16.5 18.407 16.05 18.8855 15.5 18.8855H1.5C0.95 18.8855 0.5 18.407 0.5 17.8222V15.6956C0.5 15.1108 0.95 14.6324 1.5 14.6324C2.05 14.6324 2.5 15.1108 2.5 15.6956Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b5c3dee0f68cb30bbdc5fe7e3a09ff4a.svg";
export { ForwardRef as ReactComponent };